module.exports = __webpack_public_path__ + "static/media/portfolio 2.f430e49e.JPG";